import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currentNodeChangedOnDirectLocationGroupClick,
  getCurrentNode,
  getLocationGroupText,
  getLocationQuestionOrder,
  getExpressApplication,
  getExpressImportanctFactor,
  getGroupQuestionDetailsFromQuestionTable,
} from "../store/qf";
import CmnGroupHeader from "./CmnGroupHeader";

import * as theme from "../theme";
import LocationGroupOpenedQuestions from "./LocationOpenedQuestions";

const LocationGroupHeaderAndQuestions = ({
  locationid,
  groupid,
  formid,
  mainDivRef,
  handleShowScroll,
  firstGroupId,
  lastGroupId,
  allinonepage,
}) => {
  const [open, setOpen] = useState(true);
  const [displayGroup, setdisplayGroup] = useState("flex");
  const isExpressApplication = useSelector(getExpressApplication);
  const importanceFactor = useSelector(getExpressImportanctFactor);
  const groupQuestionDetails = useSelector(
    getGroupQuestionDetailsFromQuestionTable({ formid, groupid, locationid })
  );
  const PriorityQuestions = useMemo(() => {
    return (
      groupQuestionDetails?.filter((x) => x.importance > importanceFactor) || []
    );
  }, [groupQuestionDetails, importanceFactor, formid]);
  const currentnode = useSelector(getCurrentNode);
  const groupText = useSelector(
    getLocationGroupText({ formid, groupid, locationid })
  );
  const questionsOrder = useSelector(
    getLocationQuestionOrder({ formid, groupid, locationid })
  );

  const isFirstGroup = groupid === firstGroupId;
  const isLastGroup = groupid === lastGroupId;

  const isGroupOpen =
    currentnode.groupid === groupid && currentnode.formid === formid;
  const dispatch = useDispatch();

  useEffect(() => {
    let { scrollHeight, clientHeight } = mainDivRef.current;

    if (scrollHeight > clientHeight) {
      handleShowScroll(true);
    } else {
      handleShowScroll(false);
    }
  });

  useEffect(() => {
    if (isGroupOpen === true) setOpen(true);
    //if (isGroupOpen) setOpen(true);
  }, [isGroupOpen]);

  useEffect(() => {
    setOpen(true);
  }, [currentnode.questionid]);

  useEffect(() => {
    //console.log(PriorityQuestions)
    if (isExpressApplication && PriorityQuestions?.length == 0) {
      setdisplayGroup("none");
      setOpen(false);
    } else {
      setdisplayGroup("block");
    }
  }, [isExpressApplication, PriorityQuestions]);

  const handleOpenCloseClick = () => {
    dispatch(
      currentNodeChangedOnDirectLocationGroupClick({ groupid, locationid })
    );

    if (isGroupOpen) {
      setOpen(false);
    }

    if (isGroupOpen && open === false) {
      setOpen(true);
    }
  };

  const minHeightForGroupTab = theme.SCALES.minHeightForGroupTab;

  return (
    <div style={{ minHeight: minHeightForGroupTab, display: displayGroup }}>
      <CmnGroupHeader
        text={groupText}
        isComplete={false}
        isOpen={isGroupOpen && open}
        isFirstGroup={isFirstGroup}
        isLastGroup={isLastGroup}
        handleOnClick={handleOpenCloseClick}
        allinonepage={allinonepage}
        htmlid={`location_${locationid}_${groupid}`}
      ></CmnGroupHeader>
      {isGroupOpen && open ? (
        <LocationGroupOpenedQuestions
          questionsOrder={questionsOrder}
          formid={formid}
          groupid={groupid}
          isLastGroup={isLastGroup}
          locationid={locationid}
        ></LocationGroupOpenedQuestions>
      ) : null}
    </div>
  );
};

export default LocationGroupHeaderAndQuestions;
